import React from 'react'

function PurchaseOrders() {
  return (
    <div>Purchase Orders</div>
  )
}

export default PurchaseOrders